import { MessageCircle } from "lucide-react";
import { trackWhatsAppClick } from "@/lib/analytics";

export const WA_NUMBER = "27752628060";
export const WA_DISPLAY = "+27 75 262 8060";
export const waLink = (msg = "Hi BrandIn Studio, I'd like a free brand assessment.") =>
  `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${encodeURIComponent(msg)}`;

/** Open WhatsApp reliably from a click handler. Uses a synthetic anchor click
 *  so the browser treats it as a user-initiated navigation (avoids popup
 *  blockers AND wa.me's "link blocked" interstitial that can trigger when
 *  window.open is called with a long pre-filled message). */
export function openWhatsApp(msg?: string, source: string = "programmatic") {
  trackWhatsAppClick(source, { has_message: Boolean(msg) });
  const url = waLink(msg);
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function StickyWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick("sticky_button")}
      aria-label="Chat with BrandIn Studio on WhatsApp"
      className="group fixed bottom-5 right-5 z-50 hidden items-center gap-2.5 rounded-full bg-whatsapp px-5 py-3.5 text-whatsapp-foreground shadow-elegant ring-4 ring-whatsapp/25 transition-all hover:scale-105 hover:ring-whatsapp/40 sm:bottom-6 sm:right-6 sm:flex sm:px-6 sm:py-4"
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-75" />
        <MessageCircle className="relative h-6 w-6" />
      </span>
      <span className="hidden font-semibold tracking-tight sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
